var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg039Enter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 2C21.5523 2 22 2.44772 22 3V21C22 21.5523 21.5523 22 21 22H9C8.44772 22 8 21.5523 8 21V18C8 17.4477 8.44772 17 9 17C9.55228 17 10 17.4477 10 18V20H20V4H10V6C10 6.55228 9.55228 7 9 7C8.44772 7 8 6.55228 8 6V3C8 2.44772 8.44772 2 9 2H21ZM13.59 13H3C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11H13.59L12.29 9.71C11.8979 9.31788 11.8979 8.68212 12.29 8.29C12.6821 7.89788 13.3179 7.89788 13.71 8.29L16.71 11.29C16.8993 11.4778 17.0058 11.7334 17.0058 12C17.0058 12.2666 16.8993 12.5222 16.71 12.71L13.71 15.71C13.5222 15.8993 13.2666 16.0058 13 16.0058C12.7334 16.0058 12.4778 15.8993 12.29 15.71C12.1007 15.5222 11.9942 15.2666 11.9942 15C11.9942 14.7334 12.1007 14.4778 12.29 14.29L13.59 13Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg039Enter);
export default __webpack_public_path__ + "static/media/039-enter.f3f2aaca9a87fc835dd13a0a9191ce0b.svg";
export { ForwardRef as ReactComponent };